export default "/fonts/vendor/balm-ui/material-icons.woff2?f54bbe10bb65e21752bf6b3d95c597f1";